<!--
 * @Description: 对账联系函确认对账信息
 * @Autor: txp
 * @Date: 2021-05-13 14:21:25
-->
<template>
    <div class="dialogcom">
        <el-dialog
            :title="titles"
            :visible.sync="dialogVisible"
            width="30%"
            :lock-scroll="false"
            :destroy-on-close="true"
            :before-close="handleClose">
           <div>
               <div v-if="titles == '信息反馈'">
                   <el-input
                    type="textarea"
                    :rows="6"
                    placeholder="请输入反馈信息"
                    v-model="customerFeedback">
                    </el-input>
               </div>
               <div v-else>
                   <div class="flex justify_content_between">
                   <div class="curmPhone">
                       {{phoneNum}}
                   </div>
                   <div class="curmNum cursorP">
                       <div v-show="show" @click="verificationCodeEvent">获取验证码</div>
                       <div v-show="!show">{{count}}</div>
                   </div>
               </div>
               <div class="curmcon mtb20">
                   <el-input 
                    placeholder="输入验证码"
                    v-model="verificationCode"
                    clearable
                   />
               </div>
               </div>
           </div>
            <div slot="footer" class="dialog-footer">
                <div class="flex justify_content_around" v-if="titles == '信息反馈'">
                    <el-button type="primary" size="small" @click="Save(1)">取消</el-button>
                    <el-button type="primary" size="small" @click="Save(2)">确定</el-button>
                </div>
                <div v-else>
                    <el-button type="primary" size="small" @click="Save(3)">确定</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {CustomerConfirm,ControllerSave,GetPhoneVerificationCode} from '@/api/customer';
export default {
    props:{
        visible: { //是否显示
            type: Boolean,
            default: false
        },
        titles:{
            type:String,
            default:""
        },
        phoneNum:{
            type:String,
            default:""
        },
        statementCode:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            customerFeedback:"",
            verificationCode:"",
            show:true,
            count: '',
        }
    },
    computed:{
        dialogVisible: {
            get() {
                return this.visible
            },
            set(val) {
                this.$emit('update:visible', val) // openCardDialog改变的时候通知父组件
            }
        }
    },
    methods:{
        // 关闭
        handleClose () {
            this.$emit('handleClose',false)
        },
        // 获取验证码
        verificationCodeEvent(){
            let params = {
                phoneNumber:this.phoneNum,
                statementCode: this.statementCode
            }
            GetPhoneVerificationCode(params).then(res => {
                if(res.code ==  200){
                    if (!this.timer) {
                    const TIME_COUNT = 60;
                    this.count = TIME_COUNT;
                    this.show = false;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                            this.count--;
                        } else {
                            this.show = true;
                            clearInterval(this.timer);
                            this.timer = null;
                        }
                    }, 1000)}
                    this.$message.success(res.message);
                }
            }).catch(error=>{
                this.$message.error(error);
            })
        },
        // 确定提交/取消
        Save(num) {
            if(num == 2){
                let params = {
                  customerFeedback:this.customerFeedback,
                  statementCode:this.statementCode
                }
                ControllerSave({...params}).then(res => {
                     if(res.code ==  200){
                         this.$message.success(res.message);
                          this.$emit('submitPopupData',false)
                     }
                }).catch(error=>{
                    this.$message.error(error);
                })
            }
            if(num == 3){
                 let params = {
                     statementCode:this.statementCode,
                     phoneNumber:this.phoneNum,
                     verificationCode:this.verificationCode
                     } 
                  CustomerConfirm({...params}).then(res => {
                     if(res.code ==  200){
                         this.$message.success(res.message);
                          this.$emit('submitPopupData',false)
                     }
                }).catch(error=>{
                    this.$message.error(error);
                })
            }else {
                this.$emit('handleClose',false)
            }
           
        },
    }
}
</script>
<style lang="scss" scoped>
    .dialogcom{
        /deep/ .el-dialog__footer{
        text-align: center;
        }
        /deep/.el-button--small{
            width: 120px;
        }
        /deep/.el-dialog__body{
            padding: 10px 20px;
        }
        .curmPhone{
            width: 60%;
            background: #fafafa;
            text-align: center;
            margin-right: 20px;
            border: 1px solid #d8d8d8;
            padding: 8px;
        }
        .curmNum{
            flex: 1;
            background: $color-primary;
            text-align: center;
            color: #fff;
           padding: 8px;
            border-radius: 20px;

        }
    }
</style>

